import { api } from './apiClient'

export const InvestmentsApi = {
  /**
   * Query investments with OData params.
   */
  getInvestments(params = {}) {
    return api.get('/api/investments', params)
  },

  /**
   * Get a single investment by ID.
   */
  getInvestment(investmentId) {
    return api.get(`/api/investments/${investmentId}`)
  },

  /**
   * Create a new investment.
   * @param {{ name: string, status?: string, email?: string, fundIds?: string[] }} data
   */
  createInvestment(data) {
    return api.post('/api/investments', data)
  },

  /**
   * Update an investment.
   */
  updateInvestment(investmentId, data) {
    return api.put(`/api/investments/${investmentId}`, data)
  },

  /**
   * Soft-delete an investment.
   */
  deleteInvestment(investmentId) {
    return api.delete(`/api/investments/${investmentId}`)
  },

  /**
   * Get all investments with their latest performance values (ebitdaAtEntry, ebitdaLatest).
   * Replaces the old Firebase getPerformance callable.
   */
  getPerformance() {
    return api.get('/api/investments/performance')
  },

  /**
   * Get investments for a specific fund.
   */
  getFundInvestments(fundId, params = {}) {
    return api.get(`/api/funds/${fundId}/investments`, params)
  },

  /**
   * Get performance values (ebitdaAtEntry, ebitdaLatest) for investments in a specific fund.
   */
  getFundInvestmentPerformance(fundId) {
    return api.get(`/api/funds/${fundId}/investments/performance`)
  },

  /**
   * Get user-role assignments for an investment.
   */
  getInvestmentUsers(investmentId) {
    return api.get(`/api/investments/${investmentId}/users`)
  },

  /**
   * Set user-role assignments for an investment.
   */
  setInvestmentUsers(investmentId, data) {
    return api.put(`/api/investments/${investmentId}/users`, data)
  }
}
